// src/components/Merchants/Modal/EquipmentHistoryModal.jsx
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Typography,
  Chip,
  CircularProgress,
  Skeleton,
  Paper,
} from '@mui/material';

/**
 * historyLogs: array of { id, note, created_at, status: { id, name, ... } }
 * (API: /equipments/:id/equipment-logs → equipment_logs)
 */
const EquipmentHistoryModal = ({
  open,
  onClose,
  historyLogs = [],
  loading = false,
  title = "Equipment History",
  emptyMessage = "No history records found",
  showLoadingIndicatorInTitle = true,
}) => {
  const hasData = Array.isArray(historyLogs) && historyLogs.length > 0;
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        {title}
        {showLoadingIndicatorInTitle && loading && <CircularProgress size={20} />}
      </DialogTitle>

      <DialogContent dividers sx={{ minHeight: 240 }}>
        {loading ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, py: 1 }}>
            {[...Array(4)].map((_, i) => (
              <Skeleton key={i} variant="rectangular" height={52} />
            ))}
          </Box>
        ) : !hasData ? (
          <Typography
            align="center"
            color="text.secondary"
            sx={{ py: 6, fontStyle: 'italic' }}
          >
            {emptyMessage}
          </Typography>
        ) : (
          <TableContainer component={Paper} sx={{ boxShadow: 1 }}>
            <Table size="small" aria-label="equipment history">
              <TableHead>
                <TableRow sx={{ bgcolor: 'grey.100' }}>
                <TableCell sx={{ fontWeight: 600, color: 'grey.700' }}>
                    Action By
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600, color: 'grey.700' }}>
                    Status
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600, color: 'grey.700' }}>
                    Note
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600, color: 'grey.700' }}>
                    Created At
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {historyLogs.map((log) => (
                  <TableRow key={log.id} hover>
                    <TableCell>
                      <Typography variant="body2">
                        {log.author?.name ?? '—'}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={log.status?.name ?? '—'}
                        size="small"
                        color={log.status?.name === 'Completed' ? 'success' : log.status?.name === 'Rejected' ? 'error' : 'default'}
                        variant="outlined"
                      />
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" color="text.secondary">
                        {log.note ?? '—'}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">
                        {log.created_at ?? '—'}
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EquipmentHistoryModal;
